export default __webpack_public_path__ + "static/about-3-f66b8521ad4707d87261cc5fa4577cd6.webp";